<template>
<div class="chapter">
<div class="inner_page">
<p class="fm">For Louis and Anka Begley. Friends.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Dedication.vue?9c2bca78